export default {
  title: {
    id: 'review_details_summary_title',
    defaultMessage: 'Overall rating',
  },
  reviews: {
    id: 'review_details_summary_reviews',
    defaultMessage: `{count, plural,
      one {# verified review}
      other {# verified reviews}
    }`,
  },
  ratingDetails: {
    id: 'review_details_summary_rating_details',
    defaultMessage: 'Rating details',
  },
  mainTitle: {
    id: 'review_main_title',
    defaultMessage: 'Value for money',
  },
  accessoriesTitle: {
    id: 'review_accessories_title',
    defaultMessage: 'Accessories',
  },
  aestheticAppearanceTitle: {
    id: 'review_aesthetic_appearance_title',
    defaultMessage: 'Outside Appearance',
  },
  batteryTitle: {
    id: 'review_battery_title',
    defaultMessage: 'Battery',
  },
  cameraTitle: {
    id: 'review_camera_title',
    defaultMessage: 'Lens & Camera',
  },
  overallPerformanceTitle: {
    id: 'review_overall_performance_title',
    defaultMessage: 'Overall performance',
  },
  packagingCleanlinessTitle: {
    id: 'review_packaging_cleanliness_title',
    defaultMessage: 'Packaging & cleanliness',
  },
  shippingTitle: {
    id: 'review_shipping_title',
    defaultMessage: 'Shipping',
  },
  seeMore: {
    id: 'review_details_summary_see_more',
    defaultMessage: 'See more',
  },
  seeLess: {
    id: 'review_details_summary_see_less',
    defaultMessage: 'See less',
  },
} as const
